import { getPlots, refreshSession } from "../net/api";
import { loadAllMarkers } from "./markers";
import { $plots, $session } from "./stores";

/**
 * A PlotsChanged frame: a plot was assigned, moved or renamed, or this account gained or lost
 * a plot role. Re-reading /v1/me keeps $myPlots (place and remove rights) in step.
 */
export async function handlePlotsChanged(): Promise<void> {
  await Promise.all([
    getPlots().then((p) => $plots.set(p)).catch(() => { /* next change retries */ }),
    refreshSession((s) => $session.set(s)).catch(() => { /* next change retries */ }),
  ]);
  void loadAllMarkers(); // roles or bounds changed: re-read and redraw (spec 2h §3.4)
}
